import * as React from 'react';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const MainTotal = ({ label , price , currency  })=>/*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__label"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        className: "cart-totals__total-price"
    }, label)), /*#__PURE__*/ React.createElement("div", {
        className: "cart-totals__value"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: price,
        currency: currency,
        className: "cart-totals__total-price"
    })))
;

export { MainTotal };
//# sourceMappingURL=MainTotal.js.map
